// extracted by mini-css-extract-plugin
export default {"PostsRecomendadosContainer":"PostsRecomendados_PostsRecomendadosContainer__oG08J","tituloSecao":"PostsRecomendados_tituloSecao__TH7G0"};